import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import CompanyViewContent, { HeaderActions } from '../../../components/Pages/Companies/View';
import Menu from '../../../components/Layout/Menu';
import CompanyProvider from '../../../components/Pages/Companies/Form/context';

const { displayName } = config;

export default function CompanyView(): React.ReactNode | null {
  document.title = `${displayName}: View customer`;

  return (
    <CompanyProvider>
      <Layout
        title="View customer"
        leftMenu={<Menu />}
        headerContent={<HeaderActions />}
      >
        <CompanyViewContent />
      </Layout>
    </CompanyProvider>
  );
}
